import * as React from 'react';

import { ParameterField } from './ParameterField';

export default function GroupingParameterField(props: {
    title?: string;
    children?: React.ReactNode | React.ReactNode[];
}) {
    let componentTitle: React.JSX.Element;

    if (props.title != null && props.title !== '') {
        componentTitle = <div className="card-header p-2">{props.title}</div>;
    }

    return (
        <ParameterField clearable={false} noTitle={true}>
            <div className="card mt-1">
                {componentTitle}

                <div className="card-body p-2">{props.children}</div>
            </div>
        </ParameterField>
    );
}

